import { computed } from 'vue'
import { useOidcAuth } from '#imports'
import { useDevOidcProfilesOverride } from '~/composables/auth/useDevOidcProfilesOverride'
import { useMe } from '~/composables/auth/useMe'
import { normalizeGardianSesameProfil } from '~~/utils/auth/e_roles'

/**
 * Profils OIDC effectifs : en labo dev, la liste simulée **remplace** `gardianSesameProfil` si définie.
 * Si la session n’a pas encore le claim, on reprend GET /v1/me.
 */
export function useEffectiveGardianRoles() {
  const { user } = useOidcAuth()
  const { me } = useMe()
  const { resolveEffectiveGardianProfiles } = useDevOidcProfilesOverride()

  const roles = computed(() => {
    const raw = (user.value as { userInfo?: { gardianSesameProfil?: string | string[] } } | null)
      ?.userInfo?.gardianSesameProfil
    const fromSession = normalizeGardianSesameProfil(raw)
    if (fromSession.length > 0) {
      return resolveEffectiveGardianProfiles(fromSession)
    }
    const fromMe = me.value?.gardianProfiles?.length
      ? me.value.gardianProfiles
      : me.value?.habilitation
    return resolveEffectiveGardianProfiles(normalizeGardianSesameProfil(fromMe))
  })

  return { roles }
}
